import { render, staticRenderFns } from "./Filtros.vue?vue&type=template&id=37ded046&scoped=true&lang=pug"
import script from "./Filtros.vue?vue&type=script&lang=js"
export * from "./Filtros.vue?vue&type=script&lang=js"
import style0 from "./Filtros.vue?vue&type=style&index=0&id=37ded046&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ded046",
  null
  
)

export default component.exports